<h1>Social event</h1>
<p>
    CIFRIS26 hihgly encourages people of different cryptography-related background to come together.
    <br>
    We will host a <b>social dinner</b>, where guests are welcome (up to one per participant, see the <a
        href="COMPLETARE">companion registration</a>).
</p>
<ul style="list-style: disc;">
    <li><b>Location: </b> <a href="https://www.satiricus.it/"><b><i>Nome Ristorante</i></b></a>, Via , Roma</li>
    <li><b>When?</b> September 11th, 20:30</li>
</ul>
<p style="color: var(--cifris_scarlet);">
	Registration permanently closed (registration deadline was September 16th). <br>
</p>
<mat-card class="off">Register</mat-card>
<mat-card class="off">Register a guest</mat-card>
<hr>
<h2>Menus</h2>
You will be asked for menu preferences after registration closes.
<div class="cards">
    <!-- carne -->
    <mat-card class="card"
        style="
    background-image: url('../../../../../../assets/images/events/2024/cifris24/satiricus-menu-carne.jpg'); background-size: cover; background-position-y: center;">
        <h1 class="mat-headline">Meat Menu</h1>
        <p>
            Buffalo and speck bundles with almonds and balsamic glaze
            <br>
            Beef ragù lasagna
            <br>
            Roast veal with green peppercorns
            <br>
            Cooked vegetables and roasted potatoes
            <br>
            Mimosa cake
        </p>
    </mat-card>
    <!-- pesce -->
    <mat-card class="card"
        style="
    background-image: url('../../../../../../assets/images/events/2024/cifris24/satiricus-menu-pesce.jpg'); background-size: cover; background-position-y: center;">
        <h1 class="mat-headline">Fish Menu</h1>
        <p>
            Octopus and potato salad
            <br>
            Fisherman’s risotto
            <br>
            Gratinated sea bass fillet
            <br>
            Mint mashed potatoes and steamed vegetables
            <br>
            Fruit salad with ice cream
        </p>
    </mat-card>
    <!-- vegetariano -->
    <mat-card class="card"
        style="
    background-image: url('../../../../../../assets/images/events/2024/cifris24/satiricus-menu-vegano.jpg'); background-size: cover; background-position-y: center;">
        <h1 class="mat-headline">Vegan Menu</h1>
        <p>
            Layered vegetables gratin on pumpkin cream with crispy onions
            <br>
            Risotto with porcini mushrooms and saffron
            <br>
            Sicilian caponata with roasted potatoes and thyme croutons
            <br>
            Fruit salad
        </p>
    </mat-card>
</div>
<hr>
